/** @jsxImportSource @emotion/react */
import { css, CSSObject } from "@emotion/react";

import { SetStateAction } from "react";

import { Trans } from "react-i18next";

import { colors } from "@dotnet/telematics-design-system";

import Checkbox from "../../../../components/CheckBox/Checkbox";
import Separator from "../../../../components/Separator/Separator";
import TextLink from "../../../../components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "../../../../components/TextLink/types";
import { inputFieldMarginBottom } from "../../../../shared";

interface TermsOfServiceCheckboxProps {
  acceptedTOS: boolean;
  termsOfServiceCSS: CSSObject;
  setAcceptedTOS: (value: SetStateAction<boolean>) => void;
}

const TermsOfServiceCheckbox = ({
  acceptedTOS,
  termsOfServiceCSS,
  setAcceptedTOS
}: TermsOfServiceCheckboxProps) => {
  return (
    <>
      <Separator color={colors.gray200} css={css(inputFieldMarginBottom)} />
      <Checkbox
        data-testid="tos-checkbox"
        checked={acceptedTOS}
        onChange={() => setAcceptedTOS(!acceptedTOS)}
        customLabel={
          <Trans
            i18nKey="Auth##terms and conditions"
            components={{
              1: (
                <TextLink
                  noFlex
                  href="https://teltonika-iot-group.com/policies-certificates/teltonika-terms-of-service"
                  target="_blank"
                  rel="noreferrer"
                  underline="none"
                  size={TEXT_LINK_SIZES.Normal}
                />
              ),
              2: (
                <TextLink
                  noFlex
                  href="https://teltonika-iot-group.com/policies-certificates/data-proccesing-agreement"
                  target="_blank"
                  rel="noreferrer"
                  underline="none"
                  size={TEXT_LINK_SIZES.Normal}
                />
              )
            }}
          />
        }
        customStyle={css(termsOfServiceCSS)}
      />
    </>
  );
};

export default TermsOfServiceCheckbox;
